/*import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as posenet from '@tensorflow-models/posenet';
import '@tensorflow/tfjs';

@Component({
  selector: 'app-squat',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './squat.component.html',
  styleUrls: ['./squat.component.css']
})
export class SquatComponent implements AfterViewInit {
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef;
  @ViewChild('canvasElement', { static: false }) canvasElement!: ElementRef;
  @ViewChild('feedbackElement', { static: false }) feedbackElement!: ElementRef;

  private video!: HTMLVideoElement;
  private canvas!: HTMLCanvasElement;
  private ctx!: CanvasRenderingContext2D | null;
  private net!: posenet.PoseNet;
  private guidePoints: any[] = [];
  private correctMovementsCount: number = 0;

  async ngAfterViewInit() {
    this.video = this.videoElement.nativeElement;
    this.canvas = this.canvasElement.nativeElement;
    this.ctx = this.canvas.getContext('2d');
    this.feedbackElement.nativeElement.innerText = '';

    await this.setupCamera();
    this.net = await posenet.load();
    this.detectPose();
  }

  async setupCamera() {
    this.video.width = 640;
    this.video.height = 480;
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    this.video.srcObject = stream;
    return new Promise((resolve) => {
      this.video.onloadedmetadata = () => {
        this.video.play();
        resolve(true);
      };
    });
  }

  async detectPose() {
    const pose = await this.net.estimateSinglePose(this.video, {
      flipHorizontal: false
    });

    this.drawPose(pose);
    requestAnimationFrame(() => this.detectPose());
  }

  drawPose(pose: posenet.Pose) {
    if (!this.ctx) return;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

    pose.keypoints.forEach((keypoint) => {
      if (keypoint.score > 0.5) {
        this.ctx!.beginPath();
        this.ctx!.arc(keypoint.position.x, keypoint.position.y, 5, 0, 2 * Math.PI);
        this.ctx!.fillStyle = 'red';
        this.ctx!.fill();
      }
    });

    this.checkSquat(pose);
  }

  checkSquat(pose: posenet.Pose) {
    const leftHip = pose.keypoints.find(p => p.part === 'leftHip');
    const leftKnee = pose.keypoints.find(p => p.part === 'leftKnee');
    const leftAnkle = pose.keypoints.find(p => p.part === 'leftAnkle');

    if (leftHip && leftKnee && leftAnkle) {
      const kneeAngle = this.calculateAngle(leftHip.position, leftKnee.position, leftAnkle.position);

      if (kneeAngle < 90) {
        this.feedbackElement.nativeElement.innerText = "💪 Squat Correct !";
        this.feedbackElement.nativeElement.style.color = 'green';
        this.correctMovementsCount++;

        if (this.correctMovementsCount >= 3) {
          this.guidePoints = []; // Effacer les points guides après 3 mouvements corrects
        }
      } else {
        this.feedbackElement.nativeElement.innerText = "⚠️ Descends plus bas !";
        this.feedbackElement.nativeElement.style.color = 'red';

        this.showGuidePoints(pose);
      }
    }
  }

  showGuidePoints(pose: posenet.Pose) {
    if (this.guidePoints.length === 0) {
      // Initialiser les points guides (peut être ajusté en fonction des parties du corps que tu veux comme guide)
      const leftKnee = pose.keypoints.find(p => p.part === 'leftKnee');
      const leftHip = pose.keypoints.find(p => p.part === 'leftHip');
      const leftAnkle = pose.keypoints.find(p => p.part === 'leftAnkle');

      if (leftKnee && leftHip && leftAnkle) {
        this.guidePoints = [
          { part: 'leftKnee', position: leftKnee.position },
          { part: 'leftHip', position: leftHip.position },
          { part: 'leftAnkle', position: leftAnkle.position }
        ];
      }
    }

    // Afficher les points guides
    this.guidePoints.forEach((guidePoint) => {
      this.ctx!.beginPath();
      this.ctx!.arc(guidePoint.position.x, guidePoint.position.y, 5, 0, 2 * Math.PI);
      this.ctx!.fillStyle = 'blue';
      this.ctx!.fill();
    });

    // Animation des points guides (ils bougent légèrement pour attirer l'attention)
    this.guidePoints.forEach((guidePoint) => {
      guidePoint.position.x += (Math.random() - 0.5) * 10; // Déplacement aléatoire
      guidePoint.position.y += (Math.random() - 0.5) * 10; // Déplacement aléatoire
    });
  }

  calculateAngle(A: any, B: any, C: any) {
    const AB = { x: B.x - A.x, y: B.y - A.y };
    const BC = { x: C.x - B.x, y: C.y - B.y };
    const dotProduct = AB.x * BC.x + AB.y * BC.y;
    const magnitudeAB = Math.sqrt(AB.x ** 2 + AB.y ** 2);
    const magnitudeBC = Math.sqrt(BC.x ** 2 + BC.y ** 2);
    return Math.acos(dotProduct / (magnitudeAB * magnitudeBC)) * (180 / Math.PI);
  }
}

import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as posenet from '@tensorflow-models/posenet';
import '@tensorflow/tfjs';

@Component({
  selector: 'app-squat',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './squat.component.html',
  styleUrls: ['./squat.component.css']
})
export class SquatComponent implements AfterViewInit {
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef;
  @ViewChild('canvasElement', { static: false }) canvasElement!: ElementRef;
  @ViewChild('feedbackElement', { static: false }) feedbackElement!: ElementRef;

  private video!: HTMLVideoElement;
  private canvas!: HTMLCanvasElement;
  private ctx!: CanvasRenderingContext2D | null;
  private net!: posenet.PoseNet;
  private guidePoints: any[] = [];
  private correctMovementsCount: number = 0;

  async ngAfterViewInit() {
    this.video = this.videoElement.nativeElement;
    this.canvas = this.canvasElement.nativeElement;
    this.ctx = this.canvas.getContext('2d');
    this.feedbackElement.nativeElement.innerText = '';

    await this.setupCamera();
    await this.loadModel();
    this.detectPose();
  }

  async setupCamera() {
    this.video.width = 640;
    this.video.height = 480;
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    this.video.srcObject = stream;
    return new Promise((resolve) => {
      this.video.onloadedmetadata = () => {
        this.video.play();
        resolve(true);
      };
    });
  }

  async loadModel() {
    this.net = await posenet.load();
  }

  async detectPose() {
    const pose = await this.net.estimateSinglePose(this.video, {
      flipHorizontal: false
    });

    this.drawPose(pose);
    this.detectMovements(pose);

    requestAnimationFrame(() => this.detectPose());
  }

  drawPose(pose: posenet.Pose) {
    if (!this.ctx) return;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

    pose.keypoints.forEach((keypoint) => {
      if (keypoint.score > 0.5) {
        this.ctx!.beginPath();
        this.ctx!.arc(keypoint.position.x, keypoint.position.y, 5, 0, 2 * Math.PI);
        this.ctx!.fillStyle = 'red';
        this.ctx!.fill();
      }
    });
  }

  detectMovements(pose: posenet.Pose) {
    const movements = ['squat', 'kick', 'jump', 'grab_one_hand', 'grab_two_hands'];
    movements.forEach((movement) => {
      if (this.checkMovement(pose, movement)) {
        this.feedbackElement.nativeElement.innerText = `✔️ ${movement.replace('_', ' ')} correct !`;
        this.feedbackElement.nativeElement.style.color = 'green';
        this.correctMovementsCount++;
      }
    });
  }

  checkMovement(pose: posenet.Pose, movement: string): boolean {
    const leftHip = pose.keypoints.find(p => p.part === 'leftHip');
    const leftKnee = pose.keypoints.find(p => p.part === 'leftKnee');
    const leftAnkle = pose.keypoints.find(p => p.part === 'leftAnkle');
    const rightHand = pose.keypoints.find(p => p.part === 'rightWrist');
    const leftHand = pose.keypoints.find(p => p.part === 'leftWrist');

    switch (movement) {
      case 'squat':
        return Boolean(leftHip && leftKnee && leftAnkle && this.calculateAngle(leftHip.position, leftKnee.position, leftAnkle.position) < 90);
      case 'kick':
        return Boolean(leftKnee && leftAnkle && Math.abs(leftAnkle.position.y - leftKnee.position.y) > 50);
      case 'jump':
        return Boolean(leftAnkle && leftAnkle.position.y < 300);
      case 'grab_one_hand':
        return Boolean(rightHand && leftHand && Math.abs(rightHand.position.x - leftHand.position.x) < 50);
      case 'grab_two_hands':
        return Boolean(rightHand && leftHand && Math.abs(rightHand.position.y - leftHand.position.y) < 50);
      default:
        return false;
    }
  }

  calculateAngle(A: any, B: any, C: any) {
    const AB = { x: B.x - A.x, y: B.y - A.y };
    const BC = { x: C.x - B.x, y: C.y - B.y };
    const dotProduct = AB.x * BC.x + AB.y * BC.y;
    const magnitudeAB = Math.sqrt(AB.x ** 2 + AB.y ** 2);
    const magnitudeBC = Math.sqrt(BC.x ** 2 + BC.y ** 2);
    return Math.acos(dotProduct / (magnitudeAB * magnitudeBC)) * (180 / Math.PI);
  }
}
*/

import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, ViewChild, HostListener } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as posenet from '@tensorflow-models/posenet';
import '@tensorflow/tfjs';
import * as THREE from 'three';
import { OBJLoader } from 'three/addons/loaders/OBJLoader.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

@Component({
  selector: 'app-squat',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './squat.component.html',
  styleUrls: ['./squat.component.css'],
})
export class SquatComponent implements AfterViewInit {
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef;
  @ViewChild('canvasElement', { static: false }) canvasElement!: ElementRef;
  @ViewChild('threeContainer', { static: false }) threeContainer!: ElementRef;

  private video!: HTMLVideoElement;
  private canvas!: HTMLCanvasElement;
  private ctx!: CanvasRenderingContext2D | null;
  private net!: posenet.PoseNet;

  private scene!: THREE.Scene;
  private camera!: THREE.PerspectiveCamera;
  private renderer!: THREE.WebGLRenderer;
  private objModel!: THREE.Object3D | null;
  private controls!: OrbitControls;

  private raycaster = new THREE.Raycaster();
  private mouse = new THREE.Vector2();

  async ngAfterViewInit() {
    this.video = this.videoElement.nativeElement;
    this.canvas = this.canvasElement.nativeElement;
    this.ctx = this.canvas.getContext('2d');

    await this.setupCamera();
    await this.loadPoseNetModel();
    this.setupThreeJS();
    this.loadOBJModel();
    this.detectPose();
  }

  // Configuration de la caméra pour capturer la vidéo
  async setupCamera() {
    this.video.width = 640;
    this.video.height = 480;

    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    this.video.srcObject = stream;

    return new Promise((resolve) => {
      this.video.onloadedmetadata = () => {
        this.video.play();
        resolve(true);
      };
    });
  }

  // Chargement du modèle PoseNet
  async loadPoseNetModel() {
    this.net = await posenet.load();
  }

  // Configuration de la scène Three.js
  setupThreeJS() {
    this.scene = new THREE.Scene();

    // Caméra
    this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    this.camera.position.z = 5;

    // Rendu
    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.threeContainer.nativeElement.appendChild(this.renderer.domElement);

    // Contrôles (OrbitControls pour navigation)
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);

    // Lumière
    const light = new THREE.PointLight(0xffffff, 1);
    light.position.set(10, 10, 10);
    this.scene.add(light);

    const ambientLight = new THREE.AmbientLight(0x404040); // Lumière douce
    this.scene.add(ambientLight);

    // Lancement de l'animation
    this.animate();
  }

  // Chargement du modèle OBJ
  loadOBJModel() {
    const loader = new OBJLoader();
    loader.load(
      '/ver.obj', // Assurez-vous que le chemin est correct
      (object) => {
        this.objModel = object;
        object.position.set(0, -1, -5); // Position initiale
        object.scale.set(0.5, 0.5, 0.5); // Mise à l'échelle
        this.scene.add(object);
      },
      undefined,
      (error) => {
        console.error('Erreur lors du chargement du modèle OBJ :', error);
      }
    );
  }

  // Animation de la scène Three.js
  animate() {
    requestAnimationFrame(() => this.animate());

    if (this.objModel) {
      // Exemple : Rotation automatique de l'objet
      this.objModel.rotation.y += 0.01;
    }

    this.renderer.render(this.scene, this.camera);
  }

  // Détection des poses avec PoseNet
  async detectPose() {
    const pose = await this.net.estimateSinglePose(this.video, {
      flipHorizontal: false,
    });

    if (pose) {
      this.drawPose(pose);
      if (this.objModel) {
        this.updateObjectPosition(pose);
      }
      this.checkInteraction(pose); // Nouvelle fonction pour interaction
    }

    requestAnimationFrame(() => this.detectPose());
  }
  checkInteraction(pose: posenet.Pose) {
    const leftWrist = pose.keypoints.find((keypoint) => keypoint.part === 'leftWrist');
    const rightWrist = pose.keypoints.find((keypoint) => keypoint.part === 'rightWrist');

    if (this.objModel && leftWrist && leftWrist.score > 0.5) {
      this.handleObjectGrab(leftWrist.position);
    } else if (this.objModel && rightWrist && rightWrist.score > 0.5) {
      this.handleObjectGrab(rightWrist.position);
    }
  }
  handleObjectGrab(wristPosition: { x: number; y: number }) {
    const normalizedX = (wristPosition.x / this.canvas.width) * 2 - 1;
    const normalizedY = -(wristPosition.y / this.canvas.height) * 2 + 1;

    const objPos = this.objModel?.position;
    const distance = Math.sqrt(
      (normalizedX - objPos!.x) ** 2 + (normalizedY - objPos!.y) ** 2
    );

    if (distance < 0.2) { // Si la main est proche de l'objet
      console.log("Ver attrapé !");
      this.objModel!.position.x = normalizedX * (window.innerWidth / window.innerHeight);
      this.objModel!.position.y = normalizedY * (window.innerWidth / window.innerHeight);
    }
  }

  // Dessin des points clés détectés par PoseNet sur le canvas
  drawPose(pose: posenet.Pose) {
    if (!this.ctx) {
      console.error('Canvas context is null');
      return;
    }

    // Efface le canvas avant de dessiner
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // Dessine la vidéo en arrière-plan
    this.ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

    // Dessine les points clés détectés par PoseNet
    pose.keypoints.forEach((keypoint) => {
      if (keypoint.score > 0.5) { // Seulement si la confiance est suffisante
        const { x, y } = keypoint.position;
        this.ctx?.beginPath();
        this.ctx?.arc(x, y, 5, 0, Math.PI * 2);
        this.ctx?.fill();
      }
    });
  }

  // Mise à jour de la position de l'objet en fonction des coordonnées du nez détecté par PoseNet
  updateObjectPosition(pose: posenet.Pose) {
    const nose = pose.keypoints.find((keypoint) => keypoint.part === 'nose');

    if (nose && nose.score > 0.5 && nose.position) {
      const { x, y } = nose.position;

      if (this.objModel) {
        const normalizedX = (x / this.canvas.width) * 2 - 1; // Normalisation entre -1 et +1
        const normalizedY = -(y / this.canvas.height) * 2 + 1; // Normalisation entre -1 et +1

        // Mise à jour de la position de l'objet dans la scène Three.js
        this.objModel.position.x = normalizedX * (window.innerWidth / window.innerHeight);
        this.objModel.position.y = normalizedY * (window.innerWidth / window.innerHeight);
      }
    }
  }


  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (!this.objModel) return;
    switch (event.key) {
      case 'ArrowUp':
        console.log("test")
        break;
    }
  }
}
